module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image24.f57fa3f7.webp";